import { TGetJobseekerLedgerListReqDto, TGetJobseekerLedgerListResDto, } from "@/api/services/main/talent-ledger/dtos/get-jobseeker-ledger-list.dto";
import { TUpdateJobseekerLedgerNoteReqDto, TUpdateJobseekerLedgerNoteResDto, } from "@/api/services/main/talent-ledger/dtos/update-jobseeker-ledger-note.dto";
import { TUpdateJobseekerLedgerValidPeriodReqDto, TUpdateJobseekerLedgerValidPeriodResDto, } from "@/api/services/main/talent-ledger/dtos/update-jobseeker-ledger-valid-period.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
export const getJobseekerLedgerListApi = async (params: TGetJobseekerLedgerListReqDto): Promise<TGetJobseekerLedgerListResDto> => {
    const { data } = await clientApi.get<TGetJobseekerLedgerListResDto>("/ledger/jobseeker-ledger", { params });
    return data;
};
export const useJobseekerLedgerList = (params: TGetJobseekerLedgerListReqDto, enabled = true) => {
    return useQuery({
        queryKey: [QUERY_KEYS.TALENT.FETCH_LEDGER_LIST, params],
        queryFn: () => getJobseekerLedgerListApi(params),
        enabled,
    });
};
export type TExportJobseekerLedgerReqDto = {
    fiscalYear: number;
};
export const exportJobseekerLedgerApi = async (params: TExportJobseekerLedgerReqDto) => {
    return await clientApi.get<Blob>("/ledger/jobseeker-ledger/export", { params, responseType: "blob" });
};
export const updateJobseekerLedgerNoteApi = async (caseMatchId: number, payload: TUpdateJobseekerLedgerNoteReqDto): Promise<TUpdateJobseekerLedgerNoteResDto> => {
    const { data } = await clientApi.patch<TUpdateJobseekerLedgerNoteResDto>(`/ledger/jobseeker-ledger/notes/${caseMatchId}`, payload);
    return data;
};
export type TJobseekerLedgerNotePatch = {
    caseMatchId: number;
    payload: TUpdateJobseekerLedgerNoteReqDto;
};
export const useFlushJobseekerLedgerNotes = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (patches: TJobseekerLedgerNotePatch[]) => Promise.all(patches.map(({ caseMatchId, payload }) => updateJobseekerLedgerNoteApi(caseMatchId, payload))),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.TALENT.FETCH_LEDGER_LIST] });
        },
    });
};
export const updateJobseekerLedgerValidPeriodApi = async (talentId: number, payload: TUpdateJobseekerLedgerValidPeriodReqDto): Promise<TUpdateJobseekerLedgerValidPeriodResDto> => {
    const { data } = await clientApi.patch<TUpdateJobseekerLedgerValidPeriodResDto>(`/ledger/jobseeker-ledger/valid-periods/${talentId}`, payload);
    return data;
};
export type TJobseekerLedgerValidPeriodPatch = {
    talentId: number;
    payload: TUpdateJobseekerLedgerValidPeriodReqDto;
};
export const useFlushJobseekerLedgerValidPeriods = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (patches: TJobseekerLedgerValidPeriodPatch[]) => Promise.all(patches.map(({ talentId, payload }) => updateJobseekerLedgerValidPeriodApi(talentId, payload))),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.TALENT.FETCH_LEDGER_LIST] });
        },
    });
};
